import React from 'react';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import './style.css';

class SidebarMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: '/' + this.props.pathname.split('/')[1]
    };

    this.handleChangePage = this.handleChangePage.bind(this);
  }

  isActive(name) {
    return ((name === this.state.selected) ? 'active': '');
  }

  handleChangePage(name) {
    this.setState({
      selected: name
    });
  }

  render() {
    const links = {
      home: '/',
      users: '/users',
      admins: '/admins',
      questions: '/questions',
      avatars: '/avatars',
      badges: '/badges',
      specials: '/specials',
      statistics: '/statistics',
      awards: '/awards',
      takenAwards: '/takenAwards',
      educationMaterials: '/educationMaterials',
      newsfeeds: '/newsfeeds',
      userStories: '/userStories'
    };

    return (
      <div id="sidebar-menu" className="main-menu-side hidden-print main-menu">
        <div className="menu-section">
          <h3>Hlavní menu</h3>
          <ul className="nav side-menu">
            <li className={this.isActive(links.home)} onClick={() => this.handleChangePage(links.home)}>
              <Link to={links.home}>
                <FontAwesome name="home" tag="i"/>
                Domů
              </Link>
            </li>
            <li className={this.isActive(links.admins)} onClick={() => this.handleChangePage(links.admins)}>
              <Link to={links.admins}>
                <FontAwesome name="user" tag="i"/>
                Administrátoři
              </Link>
            </li>
            <li className={this.isActive(links.avatars)} onClick={() => this.handleChangePage(links.avatars)}>
              <Link to={links.avatars}>
                <FontAwesome name="user-circle" tag="i"/>
                Avataři
              </Link>
            </li>
            <li className={this.isActive(links.newsfeeds)} onClick={() => this.handleChangePage(links.newsfeeds)}>
              <Link to={links.newsfeeds}>
                <FontAwesome name="newspaper-o" tag="i"/>
                Novinky
              </Link>
            </li>
            <li className={this.isActive(links.awards)} onClick={() => this.handleChangePage(links.awards)}>
              <Link to={links.awards}>
                <FontAwesome name="trophy" tag="i"/>
                Odměny
              </Link>
            </li>
            <li className={this.isActive(links.takenAwards)} onClick={() => this.handleChangePage(links.takenAwards)}>
              <Link to={links.takenAwards}>
                <FontAwesome name="trophy" tag="i"/>
                Odměny - vyzvednuté
              </Link>
            </li>
            <li className={this.isActive(links.badges)} onClick={() => this.handleChangePage(links.badges)}>
              <Link to={links.badges}>
                <FontAwesome name="empire" tag="i"/>
                Odznaky
              </Link>
            </li>
            <li className={this.isActive(links.questions)} onClick={() => this.handleChangePage(links.questions)}>
              <Link to={links.questions}>
                <FontAwesome name="question" tag="i"/>
                Otázky
              </Link>
            </li>
            <li className={this.isActive(links.specials)} onClick={() => this.handleChangePage(links.specials)}>
              <Link to={links.specials}>
                <FontAwesome name="exclamation" tag="i"/>
                Speciály
              </Link>
            </li>
            <li className={this.isActive(links.statistics)} onClick={() => this.handleChangePage(links.statistics)}>
              <Link to={links.statistics}>
                <FontAwesome name="bar-chart" tag="i"/>
                Statistiky
              </Link>
            </li>
            <li className={this.isActive(links.userStories)} onClick={() => this.handleChangePage(links.userStories)}>
              <Link to={links.userStories}>
                <FontAwesome name="car" tag="i"/>
                Témata soutěžících
              </Link>
            </li>
            <li className={this.isActive(links.educationMaterials)} onClick={() => this.handleChangePage(links.educationMaterials)}>
              <Link to={links.educationMaterials}>
                <FontAwesome name="graduation-cap" tag="i"/>
                Vzdělávací materiály
              </Link>
            </li>
            <li className={this.isActive(links.users)} onClick={() => this.handleChangePage(links.users)}>
              <Link to={links.users}>
                <FontAwesome name="user-o" tag="i"/>
                Uživatelé
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default SidebarMenu;



/** WEBPACK FOOTER **
 ** ./src/components/SidebarMenu/index.js
 **/